.root {
  display: flex;
  width: 100%;
}

.button {
  align-items: center;
  background: #f5f3ff;
  border: 1px solid #ddd6fe;
  border-radius: 8px;
  color: #5b21b6;
  cursor: pointer;
  display: flex;
  font: inherit;
  gap: 8px;
  padding: 8px 10px;
  text-align: left;
  width: 100%;

  &:focus-visible {
    box-shadow: 0 0 0 2px #7c3aed;
    outline: none;
  }
}

.body {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}

.title {
  color: #5b21b6;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.2;
}

.subtitle {
  color: #94a3b8;
  font-size: 9px;
  font-weight: 400;
  line-height: 1.3;
}

.chevron {
  color: #7c3aed;
  flex: none;
}

.icon {
  color: #7c3aed;
  flex: none;
}
